import { LoginRequest, LoginResponse } from '@/app/Login/domain/Auth';
import { AuthError } from '@/shared/errores/auth-error';
import { httpClient } from '@/shared/infrastructure/http-client';
import { UserProfile } from '../store/auth.store';

export async function login(dto: LoginRequest) {
  const {
    data: { data },
  } = await httpClient.post<{ data: LoginResponse }>('/Cuenta/login', dto);
  if (!data.resultado) {
    throw new AuthError(data.mensaje || 'Usuario o contraseña incorrectos');
  }
  return data;
}

export async function me(): Promise<UserProfile> {
  // await new Promise((resolve) => setTimeout(resolve, 1000));
  const { data } = await httpClient.get<UserProfile>('/Seguridad/me');
  console.log('data', data);
  return {
    id: data.id,
    username: 'test',
    email: data.email,
    profiles: data.profiles,
    permissions: data.permissions,
    isAdmin: data.isAdmin,
    isSuperAdmin: true,
    // isSuperAdmin: data.isSuperAdmin,
  };
}
